import { render, staticRenderFns } from "./VerifyUserEmail.vue?vue&type=template&id=f121b006&scoped=true"
import script from "./VerifyUserEmail.vue?vue&type=script&lang=js"
export * from "./VerifyUserEmail.vue?vue&type=script&lang=js"
import style0 from "./VerifyUserEmail.vue?vue&type=style&index=0&id=f121b006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f121b006",
  null
  
)

export default component.exports